import { Helmet } from "react-helmet-async";

const SITE_URL = "https://orbagag.com";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;
const SITE_NAME = "אור בגג";

interface SEOProps {
  title?: string;
  description?: string;
  path?: string;
  image?: string;
  type?: "website" | "article";
  noindex?: boolean;
  jsonLd?: Record<string, unknown>;
}

const DEFAULT_TITLE =
  "אור בגג - מומחה גגות ופחחות בחיפה והקריות | 13 שנות ניסיון מקצועי";
const DEFAULT_DESCRIPTION =
  "זקוקים לתיקון גג מקצועי? אור בגג מציע 13 שנות ניסיון באיתור נזילות, התקנת מרזבים, פחחות ואוורור גגות בחיפה, נשר והקריות עם אחריות מלאה. לחצו לתיאום!";
const DEFAULT_KEYWORDS =
  "אור בגג, מומחה גגות, פחחות, ניסיון, מקצועי, תיקון נזילות, מרזבים, אוורור גגות, חיפה, קריות, נשר, עכו, יקנעם";

const SEO = ({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  noindex = false,
  jsonLd,
}: SEOProps) => {
  const url = `${SITE_URL}${path}`;
  const resolvedTitle = title
    ? title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`
    : DEFAULT_TITLE;
  const resolvedDescription = description ?? DEFAULT_DESCRIPTION;

  return (
    <Helmet>
      <title>{resolvedTitle}</title>
      <meta name="description" content={resolvedDescription} />
      <meta name="keywords" content={DEFAULT_KEYWORDS} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="he_IL" />
      <meta property="og:title" content={resolvedTitle} />
      <meta property="og:description" content={resolvedDescription} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={resolvedTitle} />
      <meta name="twitter:description" content={resolvedDescription} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
